import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
import { FieldsetModule } from 'primeng/fieldset';
import { SkeletonModule } from 'primeng/skeleton';
import { IndicatorChartTypeEnums } from 'src/app/enum/indicator-chart-enums';
import { IndicatorChart } from 'src/app/interfaces/custom-indicators/indicator-chart.interface';
import { CustomBarChartComponent } from '../custom-charts/custom-bar-chart/custom-bar-chart.component';
import { CustomDonutChartComponent } from '../custom-charts/custom-donut-chart/custom-donut-chart.component';

@Component({
  selector: 'app-custom-indicators',
  templateUrl: './custom-indicators.component.html',
  styleUrls: ['./custom-indicators.component.scss'],
  standalone: true,
  imports: [CommonModule, AccordionModule, FieldsetModule, SkeletonModule, CustomBarChartComponent, CustomDonutChartComponent]
})
export class CustomIndicatorsComponent implements OnChanges {

  @Input() title: string = 'Indicadores';
  @Input() charts: IndicatorChart[] = [];
  @Input() loading: boolean = false;
  @Input() expanded: boolean = true;

  readonly chartTypes = IndicatorChartTypeEnums;
  readonly chartHeight: number = 200;
  readonly containerHeight: number = this.chartHeight + 15;
  loadedOnce: boolean = false;

  ngOnChanges() {
    if (!this.loading) this.loadedOnce = true;
  }

  trackByTitle(_index: number, chart: IndicatorChart): string {
    return chart.title;
  }
}
